import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const SearchDialog = ({ open, onOpenChange }) => {
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    onOpenChange(false);
    navigate(`/search?q=${encodeURIComponent(q.trim())}`);
    setQ("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl p-0 gap-0 bg-white border-[#0A192F]/20">
        <DialogTitle className="sr-only">Search Wolfdog News</DialogTitle>
        <DialogDescription className="sr-only">Search news, legislation, and articles</DialogDescription>
        <form onSubmit={submit} className="flex items-center gap-3 p-5">
          <Search className="w-5 h-5 text-[#D4AF37]" aria-hidden="true" />
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search news, legislation, articles..."
            data-testid="search-dialog-input"
            className="flex-1 text-lg outline-none text-[#0A192F] placeholder:text-slate-400 bg-transparent"
          />
          <button
            type="submit"
            data-testid="search-dialog-submit"
            className="overline bg-[#0A192F] text-white px-4 py-2 hover:bg-[#0A192F]/90 transition-colors"
          >
            Search
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default SearchDialog;
